import {
  Alert,
  Box,
  Button,
  CardMedia,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { sell_nft } from "../../../keychain/login";
import axios from "axios";

const MAX_NFT_SELECTION = 50;

const SALE_TOKENS = [
  "HUESO",
  "VIPHUESO",
  "SWAP.HIVE",
  "SWAP.HBD",
  "STARPRO",
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "94%", sm: 560, md: 680 },
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#20252f",
  border: "1px solid rgba(255,255,255,0.18)",
  boxShadow: 24,
  p: { xs: 2, sm: 3 },
  color: "white",
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: 2,
  borderRadius: 3,
};

export const ViewInventario = ({ paginas }) => {
  const { especiales = [], generalNft = [], informacion } = useSelector(
    (state) => state.userSlice
  );

  const [barajitas, setBarajita] = useState([]);
  const [selector, setSelector] = useState({});
  const [open, setOpen] = useState(false);
  const [openPriceDialog, setOpenPriceDialog] = useState(false);
  const [precio, setPrecio] = useState("");
  const [saleToken, setSaleToken] = useState("HUESO");
  const [selectedNftIds, setSelectedNftIds] = useState([]);
  const [saleError, setSaleError] = useState("");
  const [cartas, setCartas] = useState([...especiales, ...generalNft]);

  // Filters
  const [filtroRareza, setFiltroRareza] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [orden, setOrden] = useState("");
  const [soloConNft, setSoloConNft] = useState(false);
  const [soloConStockMercado, setSoloConStockMercado] = useState(false);

  const rarezaPeso = {
    L: 4,
    E: 3,
    R: 2,
    C: 1,
  };

  const getAllCard = async () => {
    try {
      let data = [];
      let contador = 0;
      let hasMore = true;

      while (hasMore) {
        const result = await axios.post(
          "https://api.primersion.com/contracts/",
          {
            jsonrpc: "2.0",
            id: 1,
            method: "find",
            params: {
              contract: "nft",
              table: "NFTHUESOinstances",
              query: {},
              limit: 1000,
              offset: 1000 * contador,
              indexes: [],
            },
          }
        );

        const currentPage = result.data?.result || [];

        if (currentPage.length > 0) {
          contador += 1;
          data = [...data, ...currentPage];
        } else {
          hasMore = false;
        }
      }

      let dataTemp = [...especiales, ...generalNft].map((card) => ({
        ...card,
        cantidad: card?.cantidad || 0,
      }));

      data.forEach((nftInstance) => {
        if (nftInstance?.account !== "lavino") {
          dataTemp = dataTemp.map((card) =>
            card?.ide === nftInstance?.properties?.ID
              ? {
                  ...card,
                  cantidad: (card?.cantidad || 0) + 1,
                }
              : card
          );
        }
      });

      setCartas(dataTemp);
    } catch (error) {
      console.error("Unable to load NFT market stock.", error);

      setCartas(
        [...especiales, ...generalNft].map((card) => ({
          ...card,
          cantidad: card?.cantidad || 0,
        }))
      );
    }
  };

  const handleOpen = (card) => {
    setSelector(card);
    setSelectedNftIds([]);
    setSaleError("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelector({});
    setSelectedNftIds([]);
    setSaleError("");
  };

  const handleOpenPriceDialog = () => {
    if (selectedNftIds.length === 0) {
      setSaleError("Select at least one NFT before continuing.");
      return;
    }

    setPrecio("");
    setSaleToken("HUESO");
    setSaleError("");
    setOpenPriceDialog(true);
  };

  const handleClosePriceDialog = () => {
    setOpenPriceDialog(false);
    setPrecio("");
    setSaleError("");
  };

  const toggleNftSelection = (nftId) => {
    const normalizedId = String(nftId);

    setSaleError("");

    setSelectedNftIds((currentSelection) => {
      if (currentSelection.includes(normalizedId)) {
        return currentSelection.filter((id) => id !== normalizedId);
      }

      if (currentSelection.length >= MAX_NFT_SELECTION) {
        setSaleError(
          `You can select a maximum of ${MAX_NFT_SELECTION} NFTs per sale.`
        );
        return currentSelection;
      }

      return [...currentSelection, normalizedId];
    });
  };

  const selectableNftIds = useMemo(() => {
    const ids = Array.isArray(selector?.nft) ? selector.nft : [];

    return [
      ...new Set(
        ids
          .filter((item) => item !== null && item !== undefined)
          .map((item) => String(item))
      ),
    ];
  }, [selector?.nft]);

  const selectAllAvailable = () => {
    const idsToSelect = selectableNftIds.slice(0, MAX_NFT_SELECTION);

    setSelectedNftIds(idsToSelect);
    setSaleError(
      selectableNftIds.length > MAX_NFT_SELECTION
        ? `Only the first ${MAX_NFT_SELECTION} NFTs were selected.`
        : ""
    );
  };

  const clearSelection = () => {
    setSelectedNftIds([]);
    setSaleError("");
  };

  const handleConfirmSale = () => {
    const numericPrice = Number(precio);

    if (selectedNftIds.length === 0) {
      setSaleError("Select at least one NFT.");
      return;
    }

    if (selectedNftIds.length > MAX_NFT_SELECTION) {
      setSaleError(
        `You can sell a maximum of ${MAX_NFT_SELECTION} NFTs per operation.`
      );
      return;
    }

    if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
      setSaleError("Enter a valid price greater than zero.");
      return;
    }

    if (!SALE_TOKENS.includes(saleToken)) {
      setSaleError("Select a valid sale token.");
      return;
    }

    sell_nft(
      selectedNftIds,
      precio,
      saleToken,
      `Sell ${selectedNftIds.length} NFT${
        selectedNftIds.length === 1 ? "" : "s"
      } for ${precio} ${saleToken} each`
    );

    setOpenPriceDialog(false);
    setPrecio("");
  };

  useEffect(() => {
    if (!informacion?.nombre) return;

    getAllCard();

    let total = [];

    if (paginas === 2) total = especiales;
    if (paginas === 1) total = generalNft;

    setBarajita(total);
  }, [paginas, informacion?.nombre, especiales, generalNft]);

  const nfttotal = useMemo(() => {
    return [...(informacion?.nftEspecial || []), ...(informacion?.nft || [])];
  }, [informacion?.nftEspecial, informacion?.nft]);

  const inventarioConDatos = useMemo(() => {
    return barajitas.map((card) => {
      const nftUser = nfttotal.find((item) => item?.ide === card?.ide);
      const mercado = cartas.find((item) => item?.ide === card?.ide);

      return {
        ...card,
        tipo: card?.id?.[0] || "",
        cantidadUsuario: nftUser?.cantidad || 0,
        nft: nftUser?.nft || [],
        cantidadMercado: mercado?.cantidad || 0,
      };
    });
  }, [barajitas, nfttotal, cartas]);

  const inventarioFiltrado = useMemo(() => {
    let resultado = [...inventarioConDatos];

    if (filtroRareza) {
      resultado = resultado.filter((card) => card?.rareza === filtroRareza);
    }

    if (filtroTipo) {
      resultado = resultado.filter((card) => card?.tipo === filtroTipo);
    }

    if (busqueda.trim()) {
      const texto = busqueda.toLowerCase().trim();

      resultado = resultado.filter(
        (card) =>
          String(card?.id || "").toLowerCase().includes(texto) ||
          String(card?.ide || "").toLowerCase().includes(texto) ||
          String(card?.nombre || "").toLowerCase().includes(texto)
      );
    }

    if (soloConNft) {
      resultado = resultado.filter((card) => Number(card?.cantidadUsuario) > 0);
    }

    if (soloConStockMercado) {
      resultado = resultado.filter((card) => Number(card?.cantidadMercado) > 0);
    }

    if (orden) {
      resultado.sort((a, b) => {
        switch (orden) {
          case "cantidad_asc":
            return (a?.cantidadUsuario || 0) - (b?.cantidadUsuario || 0);

          case "cantidad_desc":
            return (b?.cantidadUsuario || 0) - (a?.cantidadUsuario || 0);

          case "rareza_desc":
            return (rarezaPeso[b?.rareza] || 0) - (rarezaPeso[a?.rareza] || 0);

          case "rareza_asc":
            return (rarezaPeso[a?.rareza] || 0) - (rarezaPeso[b?.rareza] || 0);

          case "mercado_desc":
            return (b?.cantidadMercado || 0) - (a?.cantidadMercado || 0);

          case "id_asc":
            return String(a?.id || "").localeCompare(String(b?.id || ""));

          default:
            return 0;
        }
      });
    }

    return resultado;
  }, [
    inventarioConDatos,
    filtroRareza,
    filtroTipo,
    busqueda,
    orden,
    soloConNft,
    soloConStockMercado,
  ]);

  const potentialTotal = useMemo(() => {
    const numericPrice = Number(precio);

    if (!Number.isFinite(numericPrice) || numericPrice <= 0) return "0";

    return (numericPrice * selectedNftIds.length).toLocaleString(undefined, {
      maximumFractionDigits: 8,
    });
  }, [precio, selectedNftIds.length]);

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      {/* FILTERS */}
      <Box
        sx={{
          background: "rgba(0,0,0,0.35)",
          width: "100%",
          maxWidth: "95%",
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          p: 1,
          mb: 1,
          borderRadius: 1,
          alignItems: "stretch",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <FormControl
          size="small"
          sx={{
            minWidth: { xs: "100%", sm: 120 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <InputLabel sx={{ color: "white" }}>Rarity</InputLabel>

          <Select
            value={filtroRareza}
            label="Rarity"
            onChange={(event) => setFiltroRareza(event.target.value)}
            sx={{ color: "white" }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="C">C</MenuItem>
            <MenuItem value="R">R</MenuItem>
            <MenuItem value="E">E</MenuItem>
            <MenuItem value="L">L</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={{
            minWidth: { xs: "100%", sm: 120 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <InputLabel sx={{ color: "white" }}>Type</InputLabel>

          <Select
            value={filtroTipo}
            label="Type"
            onChange={(event) => setFiltroTipo(event.target.value)}
            sx={{ color: "white" }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="E">E</MenuItem>
            <MenuItem value="G">G</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={{
            minWidth: { xs: "100%", sm: 180 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <InputLabel sx={{ color: "white" }}>Sort by</InputLabel>

          <Select
            value={orden}
            label="Sort by"
            onChange={(event) => setOrden(event.target.value)}
            sx={{ color: "white" }}
          >
            <MenuItem value="">Original order</MenuItem>
            <MenuItem value="cantidad_desc">My NFTs ↓</MenuItem>
            <MenuItem value="cantidad_asc">My NFTs ↑</MenuItem>
            <MenuItem value="rareza_desc">Rarity ↓</MenuItem>
            <MenuItem value="rareza_asc">Rarity ↑</MenuItem>
            <MenuItem value="mercado_desc">Market stock ↓</MenuItem>
            <MenuItem value="id_asc">ID</MenuItem>
          </Select>
        </FormControl>

        <TextField
          size="small"
          label="Search"
          value={busqueda}
          onChange={(event) => setBusqueda(event.target.value)}
          placeholder="ID, IDE or name"
          sx={{
            minWidth: { xs: "100%", sm: 220 },
            width: { xs: "100%", sm: "auto" },
            input: { color: "white" },
            label: { color: "white" },
          }}
        />

        <Button
          fullWidth
          sx={{ width: { xs: "100%", sm: "auto" } }}
          variant={soloConNft ? "contained" : "outlined"}
          onClick={() => setSoloConNft((current) => !current)}
        >
          Owned NFTs only
        </Button>

        <Button
          fullWidth
          sx={{ width: { xs: "100%", sm: "auto" } }}
          variant={soloConStockMercado ? "contained" : "outlined"}
          onClick={() => setSoloConStockMercado((current) => !current)}
        >
          Market stock only
        </Button>

        <Button
          fullWidth
          sx={{ width: { xs: "100%", sm: "auto" } }}
          color="warning"
          variant="outlined"
          onClick={() => {
            setFiltroRareza("");
            setFiltroTipo("");
            setBusqueda("");
            setOrden("");
            setSoloConNft(false);
            setSoloConStockMercado(false);
          }}
        >
          Clear filters
        </Button>
      </Box>

      {/* ALBUM */}
      <Box
        sx={{
          background: "rgba(0,0,0,0.3)",
          height: { xs: "calc(100vh - 240px)", sm: "100%" },
          minHeight: 300,
          width: "100%",
          maxWidth: "95%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "center", sm: "flex-start" },
          alignContent: "flex-start",
          overflow: "auto",
          p: 0.5,
          boxSizing: "border-box",
        }}
      >
        {inventarioFiltrado.map((card) => (
          <Box
            key={card?.ide}
            sx={{
              position: "relative",
              width: { xs: "105px", sm: "125px" },
              mr: { xs: 0.5, sm: 1 },
              mb: 1,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                color: "white",
                zIndex: 100,
                fontSize: { xs: "0.65rem", sm: "0.75rem" },
                background: "rgba(0,0,0,0.65)",
                px: 0.5,
                borderRadius: 0.5,
              }}
            >
              {card?.tipo} - {card?.cantidadUsuario}
            </Box>

            <Box
              sx={{
                position: "absolute",
                color: "#ff6868",
                zIndex: 100,
                right: 5,
                background: "rgba(0,0,0,0.85)",
                px: 0.5,
                borderRadius: 0.5,
                fontSize: { xs: "0.65rem", sm: "0.75rem" },
              }}
            >
              {card?.cantidadMercado}
            </Box>

            <CardMedia
              onClick={() => {
                if (Number(card?.cantidadUsuario) > 0) {
                  handleOpen(card);
                }
              }}
              sx={{
                filter: `grayscale(${card?.cantidadUsuario > 0 ? 0 : 1})`,
                width: "100%",
                cursor: card?.cantidadUsuario > 0 ? "pointer" : "default",
                border:
                  filtroRareza && card?.rareza === filtroRareza
                    ? "2px solid gold"
                    : "2px solid transparent",
                borderRadius: 1,
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover":
                  card?.cantidadUsuario > 0
                    ? {
                        transform: "translateY(-2px)",
                        boxShadow: "0 8px 18px rgba(0,0,0,0.35)",
                      }
                    : {},
              }}
              component="img"
              image={card?.url}
              alt={card?.nombre || card?.id || "NFT"}
            />

            <Typography
              sx={{
                color: "white",
                fontSize: { xs: "0.68rem", sm: "0.8rem" },
                textAlign: "center",
                mt: 0.5,
                lineHeight: 1.2,
                wordBreak: "break-word",
              }}
            >
              {card?.rareza} | {card?.id}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* NFT SELECTION MODAL */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="nft-selection-title"
        aria-describedby="nft-selection-description"
      >
        <Box sx={modalStyle}>
          {selector?.ide && (
            <Box
              sx={{
                width: { xs: "100%", md: 180 },
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: { xs: "135px", sm: "155px", md: "100%" },
                }}
              >
                <Chip
                  label={`${selector?.id?.[0] || ""} - ${
                    selector?.cantidadUsuario || 0
                  } owned`}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 5,
                    left: 5,
                    zIndex: 2,
                    color: "white",
                    background: "rgba(0,0,0,0.72)",
                  }}
                />

                <CardMedia
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    boxShadow: "0 10px 24px rgba(0,0,0,0.35)",
                  }}
                  component="img"
                  image={selector?.url}
                  alt={selector?.nombre || selector?.id || "NFT"}
                />
              </Box>

              <Typography
                id="nft-selection-title"
                sx={{
                  fontWeight: 800,
                  textAlign: "center",
                  fontSize: "1rem",
                }}
              >
                {selector?.id}
              </Typography>

              <Typography
                id="nft-selection-description"
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  textAlign: "center",
                  fontSize: "0.82rem",
                }}
              >
                Select the NFT instances you want to list at the same price.
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Typography sx={{ fontWeight: 800, fontSize: "1rem" }}>
                NFT instances
              </Typography>

              <Chip
                label={`${selectedNftIds.length} / ${MAX_NFT_SELECTION} selected`}
                color={
                  selectedNftIds.length === MAX_NFT_SELECTION
                    ? "warning"
                    : "primary"
                }
                variant="outlined"
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Button
                size="small"
                variant="outlined"
                onClick={selectAllAvailable}
                disabled={selectableNftIds.length === 0}
              >
                Select up to {MAX_NFT_SELECTION}
              </Button>

              <Button
                size="small"
                color="warning"
                variant="outlined"
                onClick={clearSelection}
                disabled={selectedNftIds.length === 0}
              >
                Clear selection
              </Button>
            </Box>

            {saleError && (
              <Alert
                severity="warning"
                onClose={() => setSaleError("")}
                sx={{ width: "100%" }}
              >
                {saleError}
              </Alert>
            )}

            <Divider sx={{ borderColor: "rgba(255,255,255,0.14)" }} />

            <Box
              sx={{
                maxHeight: { xs: 260, sm: 330 },
                width: "100%",
                overflowY: "auto",
                pr: 0.5,
                borderRadius: 2,
              }}
            >
              {selectableNftIds.length > 0 ? (
                selectableNftIds.map((item) => {
                  const isSelected = selectedNftIds.includes(item);
                  const selectionLimitReached =
                    selectedNftIds.length >= MAX_NFT_SELECTION && !isSelected;

                  return (
                    <Box
                      key={item}
                      onClick={() => {
                        if (!selectionLimitReached) {
                          toggleNftSelection(item);
                        }
                      }}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                        border: isSelected
                          ? "1px solid rgba(25,118,210,0.9)"
                          : "1px solid rgba(255,255,255,0.1)",
                        background: isSelected
                          ? "rgba(25,118,210,0.14)"
                          : "rgba(255,255,255,0.03)",
                        borderRadius: 1.5,
                        px: 1,
                        py: 0.6,
                        mb: 0.7,
                        cursor: selectionLimitReached
                          ? "not-allowed"
                          : "pointer",
                        opacity: selectionLimitReached ? 0.5 : 1,
                        transition:
                          "background 0.2s ease, border-color 0.2s ease",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          minWidth: 0,
                        }}
                      >
                        <Checkbox
                          checked={isSelected}
                          disabled={selectionLimitReached}
                          onChange={() => toggleNftSelection(item)}
                          onClick={(event) => event.stopPropagation()}
                          sx={{ color: "rgba(255,255,255,0.6)" }}
                        />

                        <Box sx={{ minWidth: 0 }}>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: { xs: "0.82rem", sm: "0.92rem" },
                              wordBreak: "break-word",
                            }}
                          >
                            NFT #{item}
                          </Typography>

                          <Typography
                            sx={{
                              color: "rgba(255,255,255,0.65)",
                              fontSize: "0.75rem",
                            }}
                          >
                            Card: {selector?.id}
                          </Typography>
                        </Box>
                      </Box>

                      <Chip
                        size="small"
                        label={isSelected ? "Selected" : "Available"}
                        color={isSelected ? "primary" : "default"}
                        variant={isSelected ? "filled" : "outlined"}
                      />
                    </Box>
                  );
                })
              ) : (
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.7)",
                    textAlign: "center",
                    py: 3,
                  }}
                >
                  No NFT instances are available for this card.
                </Typography>
              )}
            </Box>

            <Button
              fullWidth
              variant="contained"
              size="large"
              disabled={selectedNftIds.length === 0}
              onClick={handleOpenPriceDialog}
              sx={{
                mt: 0.5,
                fontWeight: 800,
                py: 1.1,
              }}
            >
              Sell {selectedNftIds.length || ""} selected NFT
              {selectedNftIds.length === 1 ? "" : "s"}
            </Button>

            <Button
              fullWidth
              color="inherit"
              variant="text"
              onClick={handleClose}
              sx={{ color: "rgba(255,255,255,0.72)" }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* SALE PRICE DIALOG */}
      <Dialog
        open={openPriceDialog}
        onClose={handleClosePriceDialog}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            background: "#222730",
            color: "white",
            width: { xs: "94%", sm: 420 },
            borderRadius: 3,
            m: 1,
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            py: 3,
          }}
        >
          <DialogContentText
            sx={{
              fontSize: { xs: "1.15rem", sm: "1.4rem" },
              color: "white",
              fontWeight: 800,
              textAlign: "center",
            }}
          >
            Set sale price
          </DialogContentText>

          <Typography
            sx={{
              textAlign: "center",
              color: "rgba(255,255,255,0.72)",
              fontSize: "0.86rem",
            }}
          >
            The entered price will be applied individually to each selected NFT.
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 1,
              p: 1.5,
              borderRadius: 2,
              background: "rgba(255,255,255,0.05)",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  color: "rgba(255,255,255,0.58)",
                }}
              >
                Selected NFTs
              </Typography>

              <Typography sx={{ fontWeight: 800 }}>
                {selectedNftIds.length}
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  color: "rgba(255,255,255,0.58)",
                }}
              >
                Maximum per sale
              </Typography>

              <Typography sx={{ fontWeight: 800 }}>
                {MAX_NFT_SELECTION}
              </Typography>
            </Box>
          </Box>

          {saleError && (
            <Alert
              severity="warning"
              onClose={() => setSaleError("")}
              sx={{ width: "100%" }}
            >
              {saleError}
            </Alert>
          )}

          <TextField
            autoFocus
            id="sale-price"
            label="Price per NFT"
            type="number"
            fullWidth
            value={precio}
            onChange={(event) => {
              setPrecio(event.target.value);
              setSaleError("");
            }}
            inputProps={{
              min: 0,
              step: "any",
            }}
            InputLabelProps={{ sx: { color: "#ccc" } }}
            sx={{
              input: { color: "white" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255,255,255,0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(255,255,255,0.55)",
                },
              },
            }}
          />

          <FormControl fullWidth>
            <InputLabel sx={{ color: "#ccc" }}>Sale token</InputLabel>

            <Select
              value={saleToken}
              label="Sale token"
              onChange={(event) => {
                setSaleToken(event.target.value);
                setSaleError("");
              }}
              sx={{
                color: "white",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(255,255,255,0.3)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(255,255,255,0.55)",
                },
              }}
            >
              {SALE_TOKENS.map((token) => (
                <MenuItem key={token} value={token}>
                  {token}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              background: "rgba(25,118,210,0.12)",
              border: "1px solid rgba(25,118,210,0.32)",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "rgba(255,255,255,0.64)",
              }}
            >
              Potential total before market fees
            </Typography>

            <Typography sx={{ fontSize: "1.3rem", fontWeight: 900 }}>
              {potentialTotal} {saleToken}
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            display: "flex",
            gap: 1,
            flexDirection: { xs: "column-reverse", sm: "row" },
          }}
        >
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleClosePriceDialog}
            sx={{ color: "white", borderColor: "rgba(255,255,255,0.35)" }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmSale}
            disabled={
              selectedNftIds.length === 0 ||
              !Number.isFinite(Number(precio)) ||
              Number(precio) <= 0
            }
          >
            Sell {selectedNftIds.length} NFT
            {selectedNftIds.length === 1 ? "" : "s"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
